import { EEthereumNetworkId } from '@ankr.com/provider';

import { AVAILABLE_CHAINS } from 'modules/common';
import { getProviderManager } from 'modules/core';

import { api } from '../api';
import { cacheTags } from '../cacheTags';
import { AuthError } from '../consts';

const availableChains = new Set(AVAILABLE_CHAINS);
export const {
  useSwitchNetworkMutation,
  endpoints: { switchNetwork },
} = api.injectEndpoints({
  endpoints: build => ({
    switchNetwork: build.mutation<
      EEthereumNetworkId,
      { chainId: EEthereumNetworkId }
    >({
      queryFn: async ({ chainId }) => {
        const instance = await getProviderManager();
        const provider = await instance.getETHWriteProvider();

        if (!availableChains.has(chainId)) {
          return {
            error: {
              data: AuthError.UnsupportedChainId,
              status: 0,
              params: {
                chainId,
              },
            },
          };
        }

        await provider.switchNetwork(chainId);

        return { data: chainId };
      },
      invalidatesTags: [
        cacheTags.account,
        cacheTags.balance,
        cacheTags.chainData,
        cacheTags.taskData,
      ],
    }),
  }),
});
